enum IndustryNameEnum {
    Wine = "Wine",
    Beer = "Beer",
    Spirits = "Spirits",
    Firearms = "Firearms",
}

export default IndustryNameEnum;
